import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { shouldForwardProps } from '../../utils';
import { Breakpoint, isExpanded } from '../../types';
import { Column } from '../../styles';

const Container = styled(Box, shouldForwardProps)<{ viewSize: Breakpoint }>`
    display: flex;
    width: 100%;
    margin-top: ${({ theme }) => theme.spacing(2)};
    flex-direction: ${({ viewSize }) => (isExpanded(viewSize) ? 'row' : 'column')};
    gap: ${({ theme }) => theme.spacing(3)};
    align-items: flex-start;
`;

const LeftContainer = styled(Column, shouldForwardProps)<{ viewSize: Breakpoint }>`
    gap: ${({ theme }) => theme.spacing(2)};
    width: ${({ viewSize }) => (isExpanded(viewSize) ? '68%' : '100%')};
    flex: 1;
`;

const RightContainer = styled(Column, shouldForwardProps)<{
    viewSize: Breakpoint;
}>`
    width: ${({ viewSize }) => (isExpanded(viewSize) ? '32%' : '100%')};
    gap: ${({ theme }) => theme.spacing(2)};
    padding-bottom: ${({ theme }) => theme.spacing(2)};
`;

export { Container, LeftContainer, RightContainer };
